(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
const iframes = document.querySelector('[data-content]').querySelectorAll('iframe');
const images = document.querySelector('[data-content]').querySelectorAll('img');
if (iframes.length > 0) {
iframes.forEach(iframe => {
let width = Number(iframe.width) || 0;
let height = Number(iframe.height) || 0;
const proportion = width / height;
if (!width || !height) return;
if (width <= 960) {
width = 960;
height = height * proportion;
iframe.setAttribute('width', width.toString());
iframe.setAttribute('height', height.toString());
iframe.setAttribute('uk-responsive', '');
}
});
}
if (images.length > 0) {
images.forEach(iframe => iframe.classList.add('uk-border-rounded'));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-new"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.firstType = this.container.querySelector('[uk-slideshow].js-enable-top')
        ? this.container.querySelector('[uk-slideshow].js-enable-top li').classList.contains('uk-light')
        : false;
      this.initSlideshow(this.firstType);
      this.init();
    }

    initSlideshow(flag) {
      const tmHeader = document.querySelector('.tm-header');
      if (tmHeader) {
        tmHeader.classList.toggle('uk-light', flag);
      }
    }

    init() {
      this.container.querySelector('[uk-slideshow].js-enable-top')?.addEventListener('beforeitemshow', (e) => {
        const is_light = e.target.classList.contains('uk-light');
        this.initSlideshow(is_light);
      });
    }
  }
  if (document.querySelector('[data-section-type="slideshow"]')) {
    new Slideshow(document.querySelector('[data-section-type="slideshow"]'));
  }

  } catch(e) { console.error(e); }
})();
})();
